import Footer from '../components/layout/Footer'
import { Suspense } from 'react'
import { useLocation } from 'react-router-dom'
import TopNavigationBar from '../components/layout/TopNavigationBar/page'
import AppProvidersWrapper from '../components/wrapper/AppProvidersWrapper'
import MobileBlocker from '../components/common/MobileBlocker'

const BaseLayout = ({ children, contentClassName = '' }) => {
  const location = useLocation()
  const isOracle = location.pathname === '/oracle' || location.pathname.startsWith('/oracle/')
  const isOracleCrm = location.pathname === '/oracle/crm' || location.pathname.startsWith('/oracle/crm/')
  const isOracleWorkspace = isOracle && !isOracleCrm
  const allowMobile =
    location.pathname === '/live' ||
    location.pathname.startsWith('/live/') ||
    isOracle
  const baseWrapperClassName = allowMobile
    ? 'wrapper d-flex flex-column min-vh-100'
    : 'wrapper d-flex flex-column min-vh-100 d-none d-md-flex'
  const wrapperClassName = `${baseWrapperClassName} ${isOracleWorkspace ? 'oracle-layout' : ''}`.trim()

  return (
    <AppProvidersWrapper>
      {!allowMobile && <MobileBlocker />}
      <div className={wrapperClassName}>
        <Suspense>
          <TopNavigationBar />
        </Suspense>
        <div className={`page-content flex-grow-1 ${isOracleWorkspace ? 'oracle-page-content' : ''}`.trim()}>
          <div className={`app-container ${contentClassName}`.trim()}>{children}</div>
        </div>
        {!isOracle && <Footer />}
      </div>
    </AppProvidersWrapper>
  )
}
export default BaseLayout
